module.exports = __webpack_public_path__ + "media/images/noticia01-n-75420c128eb6806a50c0de4fee493fe2.jpg";